import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { requestPersistentStorage } from './storage.js';
import { applyTheme, startTheme, storedTheme, watchSystemTheme } from './theme.js';
import './index.css';

// Risk R4: an IndexedDB eviction that takes unpushed events with it is the one
// place this system can lose user work. Ask for persistence before anything else.
void requestPersistentStorage();

/*
 * The chosen theme, before the first render rather than during it (NFR-UX-5).
 *
 * The watcher is for the browser chrome, not the page: the stylesheet follows
 * `prefers-color-scheme` by itself, while `theme-color` is set in script and
 * would otherwise still be yesterday's color after the system switched at sunset.
 */
startTheme();
watchSystemTheme(() => applyTheme(storedTheme()));

const root = document.getElementById('root');
if (!root) throw new Error('Root element missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
